var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlate2Dot5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plate-2.5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-2dot5",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.0%",
    y: "-6.0%",
    width: "112.0%",
    height: "112.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2dot5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -6,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plate-2.5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#path-2dot5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2dot5)",
    xlinkHref: "#path-2dot5"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "square",
    cx: 25,
    cy: 25,
    r: 23
  })), /*#__PURE__*/React.createElement("text", {
    id: "WORKOUT",
    fontFamily: "Pepi",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8,
    y: 33
  }, "2.5")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlate2Dot5);
export default __webpack_public_path__ + "static/media/plate-2dot5.4cf38f81.svg";
export { ForwardRef as ReactComponent };